module.exports = { "default": require("core-js/library/fn/math/imul"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/imul.js
// module id = 1040
// module chunks = 61